// extracted by mini-css-extract-plugin
export default {"pdfContainer":"FormLicenseInput_pdfContainer__xIfdu","pdfThumbnail":"FormLicenseInput_pdfThumbnail__n3HzK","pointerCursor":"FormLicenseInput_pointerCursor__sRXZt"};